import i18next from 'i18next'

const getYear = (min, max) => {
    if ((min === 0 || min === '0') && (max === 0 || max === '0')) {
        return '-'
    } else if (min !== max) {
        return `${min} - ${max}`
    }
    return max

}

export const createEasinModal = (recordInfo) => {



    let popUpText = '<div class="sibic_map_window container-fluid"><div class="row"><div class="col-12 sibic_wind_title easin">' + recordInfo.speciesName + '</div></div><div class="row">'

    if (recordInfo.file_name) {
        popUpText += '<div class="col-5"><img class="mt-3 sibic_wind_img" src="https://admin.eei.sibic.org/assets/img/species/' + recordInfo.file_name + '" alt="img window" /></div><div class="col-6 offset-1 p-0">'
    } else {
        popUpText += '<div class="col-10 offset-2 p-0">'
    }

    popUpText += '<p class="sibic_wind_subtitle sibic_wind_general mb-0 mt-0 h2">'+i18next.t("generalInfo")+'</p>'
        + '    <p class="sibic_wind_info mb-0 mt-0">'
        + '       <strong>'+i18next.t("filtro-taxonomia")+':</strong> ' + recordInfo.family + '<br/>'
        + '       <strong>'+i18next.t("filtro-entorno")+':</strong> ' + recordInfo.habitats.map(h => h.description).join(', ') + '<br/>'
        + '       <strong>'+i18next.t("date_record")+':</strong> ' + getYear(recordInfo.yearMin, recordInfo.yearMax) + '<br/>'
        + '    </p>'
        + '    <br/>'
        + '    </div>'
        + '</div>'
        + '</div>';

    return popUpText;
}
